import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import angryIdiot from '../../assets/images/angryIdiot.png';
import curiousIdiot from '../../assets/images/curiousIdiot.png';
import hungryIdiot from '../../assets/images/hungryIdiot.png';
import evAdvocate from '../../assets/images/evAdvocate.png';

const PEOPLE = [
  { name: 'Angry Idiot', img: angryIdiot, quote: "I'm not letting you take my gas car away.", tag: 'Open to change: no', tone: 'g1' },
  { name: 'Curious Idiot', img: curiousIdiot, quote: "I'm sure there are pros and cons.", tag: 'Cautiously open', tone: 'g2' },
  { name: 'Hungry Idiot', img: hungryIdiot, quote: "I'm interested in owning an EV myself.", tag: 'Actively shopping', tone: 'g3' },
  { name: 'EV Advocate', img: evAdvocate, quote: "I'm passionate about EVs, and I'm likely annoying you.", tag: 'Already converted', tone: 'g4' },
];

export default function QuizRow() {
  return (
    <section className="fi-quiz" id="quiz" aria-labelledby="fi-quiz-h">
      <div className="fi-wrap">
        <div className="fi-sec-h">
          <div>
            <h2 className="fi-h2" id="fi-quiz-h">What kind of idiot are you?</h2>
            <p className="fi-sub">Five questions. Brutally honest results. Then send it to the idiot in your life.</p>
          </div>
          <RouterLink className="fi-btn fi-btn--ink" to="/what-kind-of-idiot" onClick={() => { if (window.gtag) window.gtag('event', 'home_cta_quiz', {}); }}>
            Take the quiz
          </RouterLink>
        </div>
        <div className="fi-chars" data-track-context="home_persona_cards">
          {PEOPLE.map((p) => (
            <RouterLink key={p.name} className="fi-ch" to={`/persona/${encodeURIComponent(p.name)}`}>
              <img className={`fi-${p.tone}`} src={p.img} width="116" height="116" alt="" loading="lazy" />
              <h3>{p.name}</h3>
              <q>{p.quote}</q>
              <span className={`fi-tag fi-${p.tone}`}>{p.tag}</span>
            </RouterLink>
          ))}
        </div>
      </div>
    </section>
  );
}
